<template>
  <q-item
    v-bind="{ clickable, disable, dense, active, activeClass, tag, dark, insetLevel, tabindex, manualFocus, focused }"
    @click="$emit('click')"
  >
    <q-item-section>
      <q-item-label class="module-name" style="max-width: 600px;">
        <span v-if="item.shorthand_name" class="text-weight-bolder">
          ({{ truncateString(item.shorthand_name, 11) }})
        </span>
        {{ item.name }}
      </q-item-label>
      <slot
        v-if="hasContentSlot"
        name="content"
      />
    </q-item-section>
    <q-item-section
      v-if="hasDefaultSlot"
      side
      class="q-ml-sm"
    >
      <slot />
    </q-item-section>
  </q-item>
</template>

<script>
import itemMixin from 'src/helpers/item'

/*
  Partial to display appointment default information on any page
*/
export default {
  mixins: [itemMixin],
  props: {
    item: {
      required: true,
      type: Object
    }
  },
  computed: {
    hasDefaultSlot () {
      return !!this.$slots.default
    },
    hasContentSlot () {
      return !!this.$slots.content
    }
  }
}
</script>
